@if (errorMessage) {
  <tidy-error-message
    [text]="errorMessage" />
}

@for (item of genomeItems; track item) {
  <tidy-card>
    <tidy-row class="vertical-align-center">
      <tidy-image
        [src]="'assets/img/light-bulb.svg'"
        class="header-size" />
      <tidy-text
        [header]="item.header_text"
        style="padding-top: 4px" />
    </tidy-row>
    @for (body of item.components; track body) {
      @if (body?.key === 'text') {
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [body]="body.value" />
        </tidy-row>
      }
      @if (body?.key === 'multiline_text') {
        <tidy-row class="extra-bottom-padding">
          @for (value of body.value; track value) {
            <tidy-text
              [body]="value.html" />
          }
        </tidy-row>
      }
    }
    <form [formGroup]="form">
      @for (component of item.components; track component) {
        @switch (component.key) {
          @case ('grouped_action_buttons') {
            @for (componentValue of component.value; track componentValue) {
              @if (componentValue.action === 'mark_suggestion_as_done') {
                <tidy-button
                  (click)="submitAction(item, component, componentValue)"
                  [text]="componentValue.value"
                  class="primary" />
              }
            }
            @for (componentValue of component.value; track componentValue) {
              @if (componentValue.action === 'hide_suggestion_for_customer') {
                <tidy-row [align]="'center'" class="extra-top-padding">
                  <tidy-text
                    class="link"
                    [body]="componentValue.value"
                    (action)="submitAction(item, component, componentValue)" />
                </tidy-row>
              }
            }
          }
          @case ('input') {
            @switch (component.value.input_type) {
              @case ('radio') {
                <tidy-row class="extra-bottom-padding">
                  <tidy-radio-button
                    formControlName="action"
                    [form]="form.controls.action"
                    [items]="component.value.input_values"
                    class="horizontal-alignment no-wrap" />
                </tidy-row>
                <tidy-row>
                  <tidy-button
                    (click)="submitAction(item, component)"
                    [text]="'Submit'"
                    class="primary" />
                </tidy-row>
              }
              @case ('select') {
                <tidy-row class="field-top-padding extra-bottom-padding">
                  <tidy-select
                    [icon]="'assets/svg/list.svg'"
                    [label]="'Select'"
                    [form]="form.controls.action"
                    formControlName="action"
                    [items]="component.value.input_values" />
                </tidy-row>
                <tidy-row>
                  <tidy-button
                    (click)="submitAction(item, component)"
                    [text]="'Submit'"
                    class="primary" />
                </tidy-row>
              }
              @case ('checkbox') {
                <tidy-row class="extra-bottom-padding">
                  @for (key of component.value.input_values; track key) {
                    <tidy-checkbox
                      [form]="form.controls.action"
                      (click)="setCheckboxValue(key)"
                      [items]="[{viewValue: key.viewValue , value: key.value}]" />
                  }
                </tidy-row>
                <tidy-row>
                  <tidy-button
                    (click)="submitAction(item, component)"
                    [text]="'Submit'"
                    class="primary" />
                </tidy-row>
              }
              @case ('text') {
                <div class="input-button-row field-top-padding">
                  <tidy-input
                    [icon]="'assets/svg/create.svg'"
                    formControlName="action"
                    [label]="component?.value?.placeholder"
                    [form]="form"
                    errorMessage="Invalid Entry"
                    [submitted]="submitted"
                    style="width: 100%; padding: 0px 10px 0px 0px;" />
                  <tidy-button
                    (click)="submitAction(item, component)"
                    [text]="'Submit'"
                    [smallText]="true"
                    class="no-padding" />
                </div>
              }
              @case ('number') {
                <div class="input-button-row field-top-padding">
                  <tidy-input
                    [icon]="'assets/svg/create.svg'"
                    formControlName="action"
                    [label]="component?.value?.placeholder"
                    [form]="form"
                    errorMessage="Please enter the amount"
                    [submitted]="submitted"
                    inputMode="numeric"
                    [mask]="'number'"
                    style="width: 100%; padding: 0px 10px 0px 0px;" />
                  <tidy-button
                    (click)="submitAction(item, component)"
                    [text]="'Submit'"
                    [smallText]="true"
                    class="no-padding" />
                </div>
              }
            }
          }
          @case ('link') {
            <tidy-card-button (action)="genomeRedirect(component.value.url)">
              <tidy-text
                [body]="component.value.label" />
            </tidy-card-button>
          }
        }
      }
    </form>
  </tidy-card>
}
